
export class FieldUpdateModel {
    public id: string;

    constructor(id: string="") {
        this.id = id;
    }
}
